import _ from "lodash"

function keysToCamel(obj) {
  if (_.isArray(obj)) {
    return obj.map(keysToCamel)
  } else if (_.isPlainObject(obj)) {
    return _.mapValues(
      _.mapKeys(obj, (_v, k) => _.camelCase(k)),
      v => keysToCamel(v)
    )
  }
  return obj
}

export default keysToCamel
